import { Capacitor } from "@capacitor/core";

// Fallback: the native bridge objects exist even if the JS Capacitor object missed the platform.
const hasBridge = () => typeof window !== "undefined" && !!(window.webkit?.messageHandlers?.bridge || window.androidBridge);

// True inside the Android/iOS store apps, where Stripe checkout is not allowed.
export const isNativeApp = () => {
  try { if (Capacitor.isNativePlatform()) return true; } catch { /* fall through */ }
  return hasBridge();
};

// Set to true if App Review requires the store apps to be free of real-money trading controls.
// The web app is unaffected, and the change goes live without a new app build.
const HIDE_LIVE_IN_NATIVE = false;
export const liveTradingHidden = () => HIDE_LIVE_IN_NATIVE && isNativeApp();

export const nativeDiagnostics = () => {
  let platform = "?";
  let native = "err";
  try { platform = Capacitor.getPlatform(); native = String(Capacitor.isNativePlatform()); } catch { /* ignore */ }
  const injected = typeof window !== "undefined" && !!window.Capacitor;
  return `platform=${platform} native=${native} bridge=${hasBridge()} injected=${injected}`;
};
